import { StringUtils } from '@colonist/utils';
import { GameColor } from '@colonist/ui-game';
import { GameFont } from '../GameFont.ts';
import { logError } from '../ui_utils/Utils.ts';
import { TextView } from './TextView.ts';
export class TextTruncatedView extends TextView {
    centerXInParent() {
        super.centerXInParent();
        this.repositionTextForMask();
    }
    centerX() {
        super.centerX();
        this.repositionTextForMask();
    }
    repositionTextForMask() {
        const isTextWiderThanMask = this.width > this.initialW;
        if (!isTextWiderThanMask) return;
        this.changeStyle({
            align: 'left'
        });
        this.x = this.initialX;
    }
    setText(text, fitText = true) {
        super.setText(text);
        this.updateToolTipText(text);
        if (fitText) this.sliceTextToFitContainer();
    }
    makeBold() {
        super.makeBold(false);
    }
    makeSemiBold() {
        super.makeBold(false);
    }
    removeBold() {
        super.removeBold(false);
    }
    sliceTextToFitContainer() {
        if (this.width < this.initialW) return;
        const text = this.getText();
        if (text.length <= this.numberOfDots + 1) return logError('TextViewMasked', [
            'container is too small to fit text'
        ]);
        if (!this.areLastCharactersDots(text)) {
            const dotText = this.getReplacementDotsForText();
            const textWithTrailingDots = text + dotText;
            this.setText({
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: textWithTrailingDots,
                    interpolation: {
                        escapeValue: false
                    }
                }
            }, false);
        }
        const currentText = this.getText();
        const characterIndexToRemove = currentText.length - this.numberOfDots - 1;
        const textWithoutLastNonDotChar = StringUtils.replaceStringAt(currentText, characterIndexToRemove, '');
        this.setText({
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: textWithoutLastNonDotChar,
                interpolation: {
                    escapeValue: false
                }
            }
        });
    }
    updateToolTipText(text) {
        const isContentTooLargeForContainer = this.width >= this.initialW;
        if (isContentTooLargeForContainer) {
            this.setTip(text, [
                {
                    key: 'strings:colonistCommon.utils.emptyString'
                }
            ]);
            return;
        }
        this.disableTip();
    }
    getReplacementDotsForText() {
        const dotText = '.'.repeat(this.numberOfDots);
        return dotText;
    }
    areLastCharactersDots(text) {
        const lastCharacters = text.slice(-this.numberOfDots);
        const dotText = this.getReplacementDotsForText();
        return lastCharacters == dotText;
    }
    constructor(text, x, y, w, h, container, fontSize = GameFont.Size.Normal, color = GameColor.getColor(GameColor.Color.Gray0), centerY = true){
        super(text, x, y, w, h, container, fontSize, color, centerY, {
            wordWrap: false
        }, false), this.numberOfDots = 2;
        this.sliceTextToFitContainer();
        this.updateToolTipText(text);
    }
}
